import { UserService } from '@/api/services/userService';
import { CashRegistersService } from '@/api/services/cashRegisters';
import { InfoService } from './infoService';

export default {
  user: new UserService(),
  cashRegisters: new CashRegistersService(),
  infoService: new InfoService(),
};
